import styled from 'styled-components';
import {
  borderColor2,
  topBarHeight
} from 'pages/styles';
import Color from 'color';

export const orange = Color('#d6a615').darken(0).toString();

export const mobileRes = '669px';
export const headerRes1 = '542px';
export const lFColor0 = '#7914cc';
export const lFColor = '#490c7b';
export const lFColor1 = Color('#7914cc').darken(0.4).toString();
export const lFColor2 = '#212137';
/** Inner L1 glyph of the app mark. */
export const logoInnerColor = '#601aac';
/** Outer field of the app mark. */
export const logoOuterColor = '#f4ebfe';

export const MobileStyle = styled.div<{ isHome: boolean }>`
  color: ${lFColor2};
`;

export const MobileStyleSpan = styled.div<{ isHome: boolean }>`
  color: ${lFColor};
`;

export const Container = styled.header<{ isHome: boolean }>`
  background: ${({ isHome }) => (
    isHome ? 'rgba(248, 250, 252, 0.82)' : 'white'
  )};
  backdrop-filter: ${({ isHome }) => (isHome ? 'saturate(160%) blur(12px)' : 'none')};
  -webkit-backdrop-filter: ${({ isHome }) => (isHome ? 'saturate(160%) blur(12px)' : 'none')};
  border-bottom: 1px solid ${({ isHome }) => (
    isHome ? 'rgba(15, 23, 42, 0.08)' : borderColor2
  )};
  box-shadow: ${({ isHome }) => (
    isHome ? 'none' : '0 2px 8px rgba(0,0,0,0.07)'
  )};
  height: ${topBarHeight};
  width: 100%;
  display: block;
  padding: 0 20px;
  position: ${({ isHome }) => (isHome ? 'sticky' : 'relative')};
  top: 0;
  z-index: 10;
  margin: 0;
  box-sizing: border-box;
  @media(max-width: ${headerRes1}) {
    padding: 0 12px;
  }
`;

export const Menu = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const NamePart = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
  gap: 8px;
  min-width: 0;
`;

export const MenuIcon = styled.div`
  color: ${lFColor2};
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: none;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: ${lFColor};
  }
  @media(min-width: calc(${mobileRes} + 1px)) {
    display: none;
  }
  @media(max-width: ${mobileRes}) {
    display: flex;
  }
`;

export const HotelName = styled.div<{ isHome: boolean }>`
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  min-width: 0;
  border-radius: 8px;
  padding: 4px 6px;
  margin: -4px -6px;
  transition: background 0.15s;
  &:hover {
    background: ${({ isHome }) => (isHome
      ? 'rgba(107, 33, 168, 0.06)'
      : 'rgba(73,12,123,0.06)')};
  }
`;

export const HotelNameInner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  min-width: 0;
`;

export const HotelNameText = styled.span<{ isHome: boolean }>`
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: ${lFColor2};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media(max-width: 323px) {
    font-size: 13px;
  }
`;

export const BranchBadge = styled.span<{ isHome: boolean }>`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 2px 7px;
  border-radius: 20px;
  flex-shrink: 0;
  white-space: nowrap;
  background: ${({ isHome }) => (isHome
    ? 'rgba(107, 33, 168, 0.1)'
    : Color(lFColor).lighten(2).toString())};
  color: ${({ isHome }) => (isHome ? '#6B21A8' : lFColor)};
`;

export const LogoCont = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const LogoBrandText = styled.span<{ isHome: boolean; onDark?: boolean }>`
  font-size: ${({ isHome, onDark }) => (isHome || onDark ? '16px' : '14px')};
  font-weight: 700;
  letter-spacing: ${({ isHome, onDark }) => (isHome || onDark ? '-0.01em' : '0.3px')};
  color: ${({ onDark }) => (onDark ? '#f8fafc' : lFColor2)};
  white-space: nowrap;
  user-select: none;
`;

export const LogoImg = styled.img<{ isHome: boolean; onDark?: boolean }>`
  height: ${({ isHome, onDark }) => (isHome || onDark ? '40px' : '26px')};
  width: ${({ isHome, onDark }) => (isHome || onDark ? '40px' : 'auto')};
  object-fit: contain;
  display: block;
  border-radius: ${({ isHome, onDark }) => (isHome || onDark ? '8px' : '0')};
  filter: ${({ isHome, onDark }) => (isHome || onDark ? 'none' : 'brightness(0)')};
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.8;
  }
`;

export const PoweredBy = styled.div<{ isHome: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  opacity: ${({ isHome }) => isHome ? 0.75 : 0.6};
  &:hover {
    opacity: 1;
  }
  transition: opacity 0.15s;
  @media(max-width: 460px) {
    display: none;
  }
`;

export const PoweredByLabel = styled.span<{ isHome: boolean }>`
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #888;
`;

export const SignCont = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const SignInBtn = styled.button<{ isHome: boolean }>`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.2px;
  padding: 7px 14px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid ${({ isHome }) => (
    isHome ? 'rgba(107, 33, 168, 0.16)' : Color(lFColor).lighten(0.5).toString()
  )};
  background: transparent;
  color: ${({ isHome }) => (isHome ? '#6B21A8' : lFColor)};
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  &:hover {
    background: ${({ isHome }) => (
      isHome ? 'rgba(107, 33, 168, 0.08)' : Color(lFColor).lighten(2.2).toString()
    )};
    border-color: ${({ isHome }) => (isHome ? '#6B21A8' : lFColor)};
  }
`;

export const RegisterBtn = styled.button<{ isHome: boolean }>`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 7px 14px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  background: ${({ isHome }) => (
    isHome ? 'linear-gradient(90deg, #6B21A8, #8b5cf6)' : lFColor
  )};
  color: white;
  transition: filter 0.15s, box-shadow 0.15s, transform 0.12s;
  box-shadow: ${({ isHome }) => (
    isHome ? '0 8px 20px rgba(107, 33, 168, 0.16)' : '0 1px 4px rgba(0,0,0,0.12)'
  )};
  &:hover {
    filter: ${({ isHome }) => (isHome ? 'brightness(0.96)' : 'none')};
    background: ${({ isHome }) => (
      isHome ? 'linear-gradient(90deg, #6B21A8, #8b5cf6)' : Color(lFColor).darken(0.15).toString()
    )};
    transform: ${({ isHome }) => (isHome ? 'translateY(-1px)' : 'none')};
    box-shadow: ${({ isHome }) => (
      isHome ? '0 10px 24px rgba(107, 33, 168, 0.2)' : '0 2px 8px rgba(0,0,0,0.18)'
    )};
  }
`;

export const Smaller = styled.span`
  font-weight: 400;
`;

export const HotelDesc = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin-left: auto;
`;

export const LodgeFirstCont = styled.div`
  font-size: 14px;
  margin-top: 2px;
`;

export const LodgePart = styled.div`
  display: flex;
  align-items: center;
`;

export const Lodge = styled(MobileStyle)`
  font-weight: 600;
  z-index: 2;
`;

export const First = styled(MobileStyleSpan)<{ isHome: boolean }>`
  font-size: 15px;
  font-weight: 700;
  padding: 0px 4px;
  border-radius: 2px;
  z-index: 1;
  margin-left: 2px;
  background: ${({ isHome }) => isHome ? Color(lFColor).lighten(0.6).toString()
    : Color(lFColor).lighten(2).toString()};
`;

export const LinkCont = styled.div`
  display: flex;
  align-items: center;
  margin-left: 55px;
  margin-top: 2px;
  gap: 10px;
  @media(max-width: 362px) {
    display: none;
  }
`;

export const Link = styled.nav`
  font-size: 13px;
  cursor: pointer;
  &:hover {
    color: ${orange};
  }
`;

export const Label = styled.nav`
  font-size: 13px;
  cursor: pointer;
  &:hover {
    color: ${orange};
  }
`;

export const Hyphen = styled.div`
  font-size: 14px;
`;
